export const IncidentStatuses = {
  OPEN: 'open',
  IN_PROGRESS: 'in_progress',
  RESOLVED: 'resolved',
  CLOSED: 'closed',
} as const;

export type IncidentStatus = (typeof IncidentStatuses)[keyof typeof IncidentStatuses];

export type IncidentCreatedBy = {
  id: string;
  name: string;
  email: string;
};

export type Incident = {
  id: string;
  name: string;
  status: IncidentStatus;
  description: string | null;
  createdBy: IncidentCreatedBy | null;
  /** Distinct customers attached to the incident. */
  involvedCustomerCount: number;
  createdAt: string;
  updatedAt: string | null;
};

export type IncidentPayload = {
  name: string;
  status?: IncidentStatus;
  description?: string | null;
};

export type IncidentUpdatePayload = Partial<IncidentPayload>;

/** One customer's attachment to an incident, as listed on the incident detail page. */
export type IncidentCustomer = {
  id: string;
  customerId: string;
  email: string;
  brandCode: string | null;
  app: string;
  note: string | null;
  /** What recorded the attachment: `admin` for a manual attach, `command:<name>` for a repair run. */
  source: string | null;
  /** JSON snapshot of the changed fields before the change; null when only involvement was recorded. */
  previousData: IncidentDataSnapshot | null;
  /** The same fields after the change. */
  newData: IncidentDataSnapshot | null;
  attachedAt: string;
};

export type IncidentDataSnapshot = Record<string, unknown>;

export type AttachIncidentCustomersResult = {
  incidentId: string;
  requestedCount: number;
  attachedCount: number;
  alreadyAttachedCount: number;
};
